/**
 * @generated SignedSource<<d737e6dd94c25db43340196c3fac7207>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArchiveFileLink_archiveFileLink$data = {
  readonly date: string | null | undefined;
  readonly doctypeheader: string | null | undefined;
  readonly format: string | null | undefined;
  readonly header: string | null | undefined;
  readonly icon: string | null | undefined;
  readonly size: string | null | undefined;
  readonly text: string | null | undefined;
  readonly url: string;
  readonly " $fragmentType": "ArchiveFileLink_archiveFileLink";
};
export type ArchiveFileLink_archiveFileLink$key = {
  readonly " $data"?: ArchiveFileLink_archiveFileLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArchiveFileLink_archiveFileLink">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ArchiveFileLink_archiveFileLink",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "doctypeheader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "header",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "format",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "size",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    }
  ],
  "type": "ArchiveFileLink",
  "abstractKey": null
};

(node as any).hash = "f4b3886f5ce61f9994452acf63ef6e3c";

export default node;
